import {Localization} from "../../../common/util/localization.jsx";
import ProductsDisplay  from "./productDisplay.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn.jsx";
import ResponsiveRows from "../../../common/components/ResponsiveRows.jsx";
import {withRouter} from "react-router-dom";

class CampaignProductsCard extends React.PureComponent {
    constructor(props){
        super(props);

        this.onClickSeeCampaing = this.onClickSeeCampaing.bind(this);
    }
    onClickSeeCampaing() {
        this.props.history.push("/order/campaigns");
    }
    render(){
        const {
            localization,
            productLists,
            isBlockedCustomer,
        } = this.props;
        const productCount = productLists.campaignProducts ? productLists.campaignProducts.length : 0;
        return (
            <div className="card-default">
                <div style={{display:"flex"}} >
                    <div className="dashboard-card-left">
                        <label className="dashboard-card-header">
                            {localization.text("dashboard","products")}
                        </label>
                        <div style={{height:"16px"}} />
                        <div className="dashboard-card-body-text">
                            {localization.text("dashboard","campaignProducts")}{/* TODO: Will the campaign have names */}
                        </div>
                        {productCount>0 && (
                            <div className="order-lines">
                                <div className="text-bottom-left">
                                    {localization.text("dashboard","xProducts",{count:productCount})}
                                </div>
                            </div>
                        )}
                    </div>
                    <ProductsDisplay localization={localization} products={productLists.campaignProducts || []} count={0}/>
                </div>
                <div className="hr"/>
                <div className="dashboard-card-bottom">
                    <ResponsiveRows gutters={false}>
                        <ResponsiveColumn xs={12}>
                            <button className={"btn block"} onClick={this.onClickSeeCampaing}  disabled={isBlockedCustomer}>
                                {localization.text("dashboard","seeProducts")}
                            </button>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
            </div>
        );
    }
}
CampaignProductsCard.propTypes = {
    localization: Localization.propTypes.isRequired,
    history: PropTypes.object.isRequired,
    productLists: PropTypes.object,
    isBlockedCustomer : PropTypes.bool.isRequired,
};

export default withRouter(CampaignProductsCard);